export default {
  methods: {
    uniqueId(id = '') {
      return `_${Math.random().toString(36).substr(2, 9)}_${id}`
    },
  },
}
